import '.x{position:fixed;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.fn{bottom:0px;}.ssr-plugin'
import '.gw{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gx{z-index:998;}.ssr-plugin'
import '.gy{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a9{height:100vh;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.gz{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.h0{z-index:999;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.r{flex-direction:column;}.ssr-plugin'
import '.s{align-items:center;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.bv{padding:1.5rem;}.ssr-plugin'
import '.h1{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.cl{flex-shrink:0;}.ssr-plugin'
import '.cu{flex:1;}.ssr-plugin'
import '.b8{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="x cf bi bj fn gw gx gy"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="x cf a9 a2 ae gz h0 i r"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="i s a3 bv h1 cl"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="cu b8 bv"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
